import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Chip,
} from '@mui/material';
import {
  Person,
  AccessTime,
  Edit,
  Delete,
} from '@mui/icons-material';

const SubstitutionList = ({
  substitutions,
  editSubstitution,
  deleteSubstitution,
  isComplete
}) => {
  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        Substitution List
      </Typography>
      {substitutions.length === 0 ? (
        <Typography>No substitutions added yet.</Typography>
      ) : (
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ minWidth: 120 }}><Box sx={{ display: 'flex', alignItems: 'center' }}><Person /> JR In</Box></TableCell>
                <TableCell sx={{ minWidth: 120 }}><Box sx={{ display: 'flex', alignItems: 'center' }}><Person /> JR Out</Box></TableCell>
                <TableCell sx={{ minWidth: 120 }}>Team</TableCell>
                <TableCell sx={{ minWidth: 120 }}><Box sx={{ display: 'flex', alignItems: 'center' }}><AccessTime /> Time (min)</Box></TableCell>
                <TableCell sx={{ minWidth: 100 }}>Half</TableCell>
                <TableCell sx={{ minWidth: 120 }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {substitutions.map((sub, index) => (
                <TableRow key={index}>
                  <TableCell>{sub.jerseyIn}</TableCell>
                  <TableCell>{sub.jerseyOut}</TableCell>
                  <TableCell>{sub.team}</TableCell>
                  <TableCell>{sub.time}</TableCell>
                  <TableCell>
                    <Chip
                      label={sub.half === 1 ? '1st Half' : '2nd Half'}
                      color={sub.half === 1 ? 'primary' : 'secondary'}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => editSubstitution(index)} disabled={isComplete}>
                      <Edit />
                    </IconButton>
                    <IconButton onClick={() => deleteSubstitution(index)} disabled={isComplete}>
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default SubstitutionList;